import axios from 'axios';

export type GetFolderHierarchyParams = {
  folderId: string;
};

export type GetFolderHierarchyResponse = {
  id: string;
  name: string;
  parentId: string | null;
}[];

export const getFolderHierarchy = async ({
  folderId,
}: GetFolderHierarchyParams) => {
  const { data } = await axios.get<GetFolderHierarchyResponse>(
    `/asset/folder/hierarchy/${folderId}`,
  );
  return data;
};
